import { render, staticRenderFns } from "./receivedgift.vue?vue&type=template&id=051f58e0&scoped=true&"
import script from "./receivedgift.vue?vue&type=script&lang=js&"
export * from "./receivedgift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051f58e0",
  null
  
)

export default component.exports